export const Settings = {
    DomainServerUrl: "https://domain.bloyal.io",
    SiteType: "Production",
    BackOfficeReturnUrl: "https://bldev-posreact.azurewebsites.net",
    BackOfficeReturnLocalHostUrl: "http://localhost:3001",
}